<div id="overlay"></div>
<form id="parentForm" [formGroup]="frmGroup">
    <div *ngIf="configData.groups" class="dhl-content-v2 dhl-grid-v2">
        <div *ngFor="let group of configData.groups;let grpIdx =index;">
            <div *ngIf="grpIdx !== 0" class="section-align">
                <mat-divider class="section-divider"></mat-divider>
            </div>
            <div class="dhl-group-title-v2">
                {{ group.label }}
            </div>
            <div class="row">
                <app-form-field *ngFor="let control of group.controls" [configData]="control"
                    [ngClass]="getColsClass(control.cols)" [frmGroup]="frmGroup"></app-form-field>
            </div>
        </div>
    </div>
</form>
<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
